const countryCodes = {
	GHANA: 'GHA',
	KENYA: 'KEN',
};

export default countryCodes;
